export interface IStrength {
  id: number;
  term: string;
  locale: string;
  hits: number;
}

export class Strength {
  public id: number;
  public term: string;
  public locale: string;
  public hits: number;

  constructor(data: IStrength) {
    this.id = data.id;
    this.term = data.term;
    this.locale = data.locale;
    this.hits = data.hits;
  }
}
